var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "218DAA91-B303-46A2-9069-58CF763AEE92") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1181.000000, -1518.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ProgressChart",
    transform: "translate(1181.000000, 1518.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-64",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 90,
    height: 70
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-47-Copy",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.048654, 0.048654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6802232,10.2172988 C48.3673311,10.2172988 59.4629244,21.3128921 59.4629244,35 C59.4629244,48.6871079 48.3673311,59.7827012 34.6802232,59.7827012 C20.9931153,59.7827012 9.89752204,48.6871079 9.89752204,35 C9.89752204,21.3128921 20.9931153,10.2172988 34.6802232,10.2172988 Z M34.8401116,14.3743971 C23.3606017,14.3743971 14.0546203,23.6803785 14.0546203,35.1598884 C14.0546203,46.6393983 23.3606017,55.9453797 34.8401116,55.9453797 C46.3196215,55.9453797 55.6256029,46.6393983 55.6256029,35.1598884 C55.6256029,23.6803785 46.3196215,14.3743971 34.8401116,14.3743971 Z",
    id: "Combined-Shape-Copy-2",
    fillOpacity: 0.459359976,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,10.2172988 C48.6871079,10.2172988 59.7827012,21.3128921 59.7827012,35 C59.7827012,48.6871079 48.6871079,59.7827012 35,59.7827012 C33.9551265,59.5404086 33.4326897,58.8873376 33.4326897,57.8234881 C33.4326897,56.7596386 34.0316466,56.1404937 35.2295605,55.9660535 L35.2295605,55.9660535 L35.1822988,55.9452988 L35.5106154,55.9424804 C46.8283473,55.7552354 55.9453797,46.5222604 55.9453797,35.1598884 C55.9453797,23.6803785 46.6393983,14.3743971 35.1598884,14.3743971 C23.6803785,14.3743971 14.3743971,23.6803785 14.3743971,35.1598884 C14.3743971,40.7263717 16.5625482,45.7817849 20.1256237,49.5129013 L21.4642988,50.0852988 L20.1627805,49.5297728 C20.5540926,50.4941993 20.4348948,51.2956013 19.8051871,51.9339788 L19.6724387,52.0594806 C18.9281446,52.7172308 18.0873918,52.7614301 17.1501802,52.1920784 C12.8572411,47.7359408 10.2172988,41.6762662 10.2172988,35 C10.2172988,21.3128921 21.3128921,10.2172988 35,10.2172988 Z",
    id: "Combined-Shape-Copy-6",
    fill: "#777575",
    transform: "translate(35.000000, 35.000000) rotate(-228.000000) translate(-35.000000, -35.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6802232,16.6128346 C44.8351742,16.6128346 53.0673886,24.845049 53.0673886,35 C53.0673886,45.154951 44.8351742,53.3871654 34.6802232,53.3871654 C24.5252722,53.3871654 16.2930578,45.154951 16.2930578,35 C16.2930578,24.845049 24.5252722,16.6128346 34.6802232,16.6128346 Z M34.8401116,20.7699329 C26.8927586,20.7699329 20.4501561,27.2125354 20.4501561,35.1598884 C20.4501561,43.1072414 26.8927586,49.5498439 34.8401116,49.5498439 C42.7874646,49.5498439 49.2300671,43.1072414 49.2300671,35.1598884 C49.2300671,27.2125354 42.7874646,20.7699329 34.8401116,20.7699329 Z",
    id: "Combined-Shape-Copy-3",
    fillOpacity: 0.459359976,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6746429,24.6072543 C52.829594,24.6072543 61.0619303,32.8394687 61.0619303,42.9944197 C61.0109912,44.6475886 60.3753796,45.4741731 59.1550954,45.4741731 C57.9348112,45.4741731 57.2895727,44.6475886 57.2193799,42.9944197 L57.2234776,43.0752543 L57.2211519,42.8413896 C57.0546842,35.0385284 50.6773139,28.7643526 42.8345313,28.7643526 C34.9406329,28.7643526 28.5313108,35.1205797 28.4454487,42.9941503 C28.443813,44.6475886 27.7631828,45.4741731 26.4019223,45.4741731 C25.0406618,45.4741731 24.3358469,44.6475886 24.2874776,42.9944197 C24.2874776,32.8394687 32.5196919,24.6072543 42.6746429,24.6072543 Z",
    id: "Combined-Shape-Copy-5",
    fill: "#9E9E9E",
    transform: "translate(42.674704, 35.040714) rotate(-270.000000) translate(-42.674704, -35.040714) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6802232,23.0083704 C41.3030174,23.0083704 46.6718528,28.3772058 46.6718528,35 C46.6718528,41.6227942 41.3030174,46.9916296 34.6802232,46.9916296 C28.0574291,46.9916296 22.6885936,41.6227942 22.6885936,35 C22.6885936,28.3772058 28.0574291,23.0083704 34.6802232,23.0083704 Z M34.5203348,26.8456919 C30.1051387,26.8456919 26.5259151,30.4249155 26.5259151,34.8401116 C26.5259151,39.2553077 30.1051387,42.8345313 34.5203348,42.8345313 C38.9355309,42.8345313 42.5147545,39.2553077 42.5147545,34.8401116 C42.5147545,30.4249155 38.9355309,26.8456919 34.5203348,26.8456919 Z",
    id: "Combined-Shape-Copy-4",
    fill: "#C3C1C1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#777575",
    fillRule: "evenodd",
    cx: 67.7105263,
    cy: 20.7105263,
    r: 1.71052632
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    fill: "#9E9E9E",
    fillRule: "evenodd",
    cx: 67.7105263,
    cy: 34.2105263,
    r: 1.71052632
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-25",
    fill: "#C3C1C1",
    fillRule: "evenodd",
    cx: 67.7105263,
    cy: 47.7105263,
    r: 1.71052632
  }), /*#__PURE__*/React.createElement("text", {
    id: "%80",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 72,
    y: 22,
    fill: "#000000"
  }, "%80")), /*#__PURE__*/React.createElement("text", {
    id: "%50",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 72,
    y: 35,
    fill: "#000000"
  }, "%50")), /*#__PURE__*/React.createElement("text", {
    id: "%100",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 72,
    y: 49,
    fill: "#000000"
  }, "%100")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressChart);
export default __webpack_public_path__ + "static/media/ProgressChart.68d54e1b4b9a08d170e517b5e05d2c93.svg";
export { ForwardRef as ReactComponent };